import { ChangeDetectionStrategy, Component, input, output } from '@angular/core'
import { CertificateHolderNavigationItem } from '@app/layout/sidebar/models/certificate-holder-navigation-item.model'
import { RouterLink, RouterLinkActive } from '@angular/router'
import { Tag } from 'primeng/tag'

@Component({
  selector: 'albert-list-view-ch-list-item',
  imports: [
    RouterLinkActive,
    Tag,
    RouterLink
  ],
  templateUrl: './list-view-ch-list-item.component.html',
  styleUrl: './list-view-ch-list-item.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class ListViewChListItemComponent {
  public readonly itemClicked = output()
  public readonly item = input.required<CertificateHolderNavigationItem>()
  protected readonly length = length

  public get usedIn(): number {
    return this.item().usedIn.length
  }

  public onEntryClick(): void {
    this.itemClicked.emit()
  }
}
